<div class="prd">
  <app-container>
    <h4 class="prd-title"></h4>

    <div class="prd-wrapper">
      @for (item of prdList; track item) {
        <div class="item">
          <div class="title">{{ item.regulatorTitle }}</div>
          <div class="desc">
            <div class="value">
              Рік дії плану:
              {{ item.deadline }}
            </div>

            <div class="value">
              Дата внесення плану в систему:
              {{ item.createdAt | date: "dd.MM.yyyy" }}
            </div>
            <div class="value">
              Дата затвердження плану:
              {{ item.approvalDate | date: "dd.MM.yyyy" }}
            </div>
            <div class="value">
              Реквізити затвердження плану:
              {{ item.approvalRequisites }}
            </div>
          </div>

          <div class="info-wrapper">
            <div class="info">ПІБ підписанта: {{ item.authorFullName }}</div>
            <div class="info">Посада підписанта: {{ item.authorPosition }}</div>
          </div>

          <div class="footer-info">
            <div class="counts">
              <img src="assets/img/icons/eye.svg" alt="" />

              <div class="count">{{ item.viewCount }}</div>
            </div>
            <div class="link">
              <img
                [routerLink]="['/activity', item.regPlanId]"
                src="assets/img/icons/arrow-right.svg"
                alt="arrow"
              />
            </div>
          </div>
        </div>
      }
    </div>
  </app-container>
</div>
